import Toggle from 'components/Toggle'
import InlineEdit from 'components/shared/InlineEdit'

import style from './style.styl'

const DriftLink = ({ onSlugChange, driftLinkOnly, toggleDriftLinkOnly, slug }) => (
  <div className={style.DriftLink}>
    <header className="playbook-title-header">
      <h2>Create a #DriftLink</h2>
      <p>
        Your #DriftLink is what leads will click to trigger this playbook. All you need to do is add
        it to the end of any link where Drift is installed on your website. (ex.
        drift.com/#book-a-demo).
      </p>
    </header>

    <div className="playbook-targeting-driftlink-wrapper">
      <div className="slug-container playbook-container">
        <InlineEdit className="slug-edit" onChange={onSlugChange} value={`#${slug}`} />
      </div>
      <div className="playbook-targeting-driftlink-toggle">
        <div className="playbook-targeting-driftlink-toggle-label">
          <div>Target via #DriftLink Only</div>
          <div className="subtext">
            This Playbook will only be accessible through your #DriftLink.
          </div>
        </div>
        <Toggle checked={driftLinkOnly} onChange={toggleDriftLinkOnly} />
      </div>
      <hr />
      <div className="playbook-targeting-driftlink-video">
        <div>Have questions about using #DriftLinks?</div>
        <div className="subtext">watch this video:</div>
        <iframe
          width="390"
          height="221"
          className="playbook-targeting-howto-embed"
          src="https://www.youtube.com/embed/qnQEMeM3m_E"
          frameBorder="0"
        />
      </div>
    </div>
  </div>
)

export default DriftLink



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/DriftLink/component.js